import { auSampleProjectProperties } from '@core/sample-project-properties/au.sample';
import { sgSampleProjectProperties } from '@core/sample-project-properties/sg.sample';

const defaultSampleProjectProperties = auSampleProjectProperties;

const sampleProjectPropertiesByCountry = {
	au: auSampleProjectProperties,
	sg: sgSampleProjectProperties,
} as const;

export function getSampleProjectProperties(countryCode: string) {
	return sampleProjectPropertiesByCountry[countryCode as keyof typeof sampleProjectPropertiesByCountry] ?? defaultSampleProjectProperties;
}
